import { CurrencyRates } from '@monolith/legacy/store/state';
import { Currency } from 'dinero.js';
import { getInjectedContent } from "@modules/core/services/injected-content";
import { StateMetaTagName } from "@modules/core/services/initial-state";

export const getCurrency = (): Currency => {
  const currency = getInjectedContent<Currency>(StateMetaTagName.Currency);
  if (!currency) {
    throw new Error('Currency meta tag is missing or invalid');
  }
  return currency;
};

export const getCurrencyRates = (): CurrencyRates => {
  const rates = getInjectedContent<CurrencyRates>(StateMetaTagName.CurrenciesRates);
  if (!rates) {
    throw new Error('Currency rates meta tag is missing or invalid');
  }
  return rates;
};
